/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Layout,
  Row,
  Col,
  Form,
  Card,
  Typography,
  Spin,
  Tabs,
} from 'antd';
import {
  UserOutlined,
  FileTextOutlined,
  CheckSquareOutlined,
  CalendarOutlined,
  QuestionCircleOutlined,
  SolutionOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';

// Tus componentes
import { getCandidato, getCandidatovistaOptimized } from 'api/catalogos/Candidatos';
import { checkToken } from 'api/utils';
import Select from 'components/Select';
import { getEntrevistas } from 'api/Entrevistas';
import EntrevistaNoModal from 'components/Reclutamiento/Entrevistas/EntrevistaNoModal';
import CardInforme from 'components/Reclutamiento/Entrevistas/CardInforme';
import { getEntrevistasInforme } from 'api/EntrevistasInforme';
import ContratacionesView from 'components/Reclutamiento/ContratacionView';
import { getSolicitudDeContratacionvistaOptimized } from 'api/reclutamiento/SolicitudesDeContratacion';
import CitasParaHistoricoCandidatos from 'components/Reclutamiento/CitasParaHistoricoCandidatos';
import CandidatoInfoGeneral from 'components/Reclutamiento/Entrevistas/CandidatoInfoGeneral';
import VacantesParaHistorico from './VacantesParaHistorico';

const { Content } = Layout;
const { Title, Text } = Typography;

export const reclutamientoRHPermission = {
  permissionModel: 'solicituddecontratacion',
};

const ExpedienteDeCandidato = ({ permission }) => {
  const [candidatos, setCandidatos] = useState([]);
  const [idcandidatoSeleccionado, setIDCandidatoSeleccionado] = useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const nameCandidato = 'candidato';

  const [entrevista, setEntrevista] = useState({});
  const [informe, setInforme] = useState({});
  const [vacanteId, setVacanteId] = useState({});

  const tabNameEntrevista = 'entrevista';
  const tabNameGeneral = 'general';
  const tabNameVacantes = 'vacantes';
  const tabNameInforme = 'informe';
  const tabNameCitas = 'citas';
  const tabNameContrataciones = 'contrataciones';
  const [selectedView, setSelectedView] = useState(null); // default

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _candidatos,
      ] = await Promise.all([
        getCandidatovistaOptimized(),
      ]);
      if (mounted) {
        setCandidatos(_candidatos);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onChangeCandidato = async (val) => {
    try {
      if (val == null) {
        setSelectedView(null);
        setIDCandidatoSeleccionado(null);
        return;
      }
      const _candidato = await getCandidato(val);
      const _entrevista = await getEntrevistas({ candidato: _candidato?.id });
      const _informe = await getEntrevistasInforme({ candidato: _candidato?.id });
      const _vacante = await getSolicitudDeContratacionvistaOptimized(
        { vacante_id: _candidato?.solicitud_de_contratacion?.id },
      );
      setEntrevista(_entrevista ? _entrevista?.results[0] : null);
      setInforme(_informe ? _informe?.results[0] : null);
      setVacanteId(_vacante[0]?.vacante_id);

      setIDCandidatoSeleccionado(_candidato?.id);
      setSelectedView(tabNameVacantes);
    } catch (error) {
      Error('Error al cambiar empleado:', error);
    }
  };

  const disabledTabs = idcandidatoSeleccionado === null;

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError
          name="general"
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name={nameCandidato}
                label="No. y Nombre del Candidato"
                required
                hasFeedback
              >
                <Select
                  labelProp="candidato_numero_y_nombre_completo"
                  dataSource={candidatos}
                  onChange={onChangeCandidato}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Tabs
          type="card"
          activeKey={selectedView}
          onChange={(key) => setSelectedView(key)}
          items={[
            {
              key: tabNameVacantes,
              label: (
                <>
                  <FileTextOutlined />
                  {' '}
                  Vacante
                </>
              ),
              children: <VacantesParaHistorico
                permission={permission}
                idVacante={[vacanteId]}
              />,
              disabled: disabledTabs,
            },
            {
              key: tabNameGeneral,
              label: (
                <>
                  <QuestionCircleOutlined />
                  {' '}
                  Datos Generales
                </>
              ),
              children: <CandidatoInfoGeneral
                permission={permission}
                // onClose={() => setModalVisible(false)}
                entrevista={entrevista}
              />,
              disabled: disabledTabs,
            },
            {
              key: tabNameCitas,
              label: (
                <>
                  <CalendarOutlined />
                  {' '}
                  Cita
                </>
              ),
              children: <CitasParaHistoricoCandidatos candidatoID={idcandidatoSeleccionado} />,
              disabled: disabledTabs,
            },
            {
              key: tabNameEntrevista,
              label: (
                <>
                  <QuestionCircleOutlined />
                  {' '}
                  Entrevista
                </>
              ),
              children: <EntrevistaNoModal
                permission={permission}
                // onClose={() => setModalVisible(false)}
                entrevista={entrevista}
              />,
              disabled: disabledTabs,
            },
            {
              key: tabNameInforme,
              label: (
                <>
                  <SolutionOutlined />
                  {' '}
                  Informe
                </>
              ),
              children: <CardInforme selectedData={informe} />,
              disabled: disabledTabs,
            },
            {
              key: tabNameContrataciones,
              label: (
                <>
                  <CheckCircleOutlined />
                  {' '}
                  Contratacion
                </>
              ),
              children: <ContratacionesView candidatoId={idcandidatoSeleccionado} />,
              disabled: disabledTabs,
            },
          ]}
        />
      </Spin>
    </Row>
  );
};

function MainDashboard({ setSelectedView }) {
  const iconMap = {
    vacantes: <FileTextOutlined style={{ fontSize: 18 }} />,
    pruebas: <CheckSquareOutlined style={{ fontSize: 18 }} />,
    citas: <CalendarOutlined style={{ fontSize: 18 }} />,
    user: <UserOutlined style={{ fontSize: 18 }} />,
  };
  const dashboardCards = [
    {
      key: 'vacantes', title: 'Estatus de Vacantes', count: 8,
    },
    {
      key: 'pruebas', title: 'Asignar Pruebas', count: 5,
    },
    {
      key: 'citas', title: 'Citas Programadas', count: 7,
    },
    {
      key: 'user', title: 'Entrevistas Pendientes', count: 9,
    },
  ];
  return (
    <div>
      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        {dashboardCards.map(({
          key, title, count,
        }) => (
          <Col key={key} xs={24} sm={12} lg={6}>
            <Card hoverable onClick={() => setSelectedView(key)}>
              <Row gutter={8} align="middle">
                <Col>
                  <Text strong>{title}</Text>
                </Col>
                <Col>{iconMap[key]}</Col>
              </Row>
              <Title level={3}>{count}</Title>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default ExpedienteDeCandidato;
